module.exports = __webpack_public_path__ + "img/0x7a9f28eb62c791422aa23ceae1da9c847cbec9b0.09fae496.png";